var $6726d1d017d2290c$exports = {};
console.log("Initializing animation");
const $6726d1d017d2290c$var$canvas = document.getElementById('mainCanvas');
const $6726d1d017d2290c$var$ctx = $6726d1d017d2290c$var$canvas.getContext('2d');
const $6726d1d017d2290c$var$dpr = window.devicePixelRatio;
const $6726d1d017d2290c$var$cw = window.innerWidth;
const $6726d1d017d2290c$var$ch = window.innerHeight;
$6726d1d017d2290c$var$canvas.width = $6726d1d017d2290c$var$cw * $6726d1d017d2290c$var$dpr;
$6726d1d017d2290c$var$canvas.height = $6726d1d017d2290c$var$ch * $6726d1d017d2290c$var$dpr;
$6726d1d017d2290c$var$ctx.scale($6726d1d017d2290c$var$dpr, $6726d1d017d2290c$var$dpr);
const $6726d1d017d2290c$var$center = {
    x: $6726d1d017d2290c$var$canvas.width / 2,
    y: $6726d1d017d2290c$var$canvas.height / 2
};
console.log($6726d1d017d2290c$var$center);
function $6726d1d017d2290c$var$random(min, max) {
    return min + Math.random() * (max - min);
}
const $6726d1d017d2290c$var$initialOrbCount = 100;
const $6726d1d017d2290c$var$state = {
    total: 0,
    dt: 1,
    orbs: []
};
const $6726d1d017d2290c$var$options = {
    speed: 65,
    scale: 1.0,
    radius: 300,
    fadeout: 10,
    centerLight: true,
    lightAlpha: 5,
    perfectRed: false,
    spiralInwards: false
};
const $6726d1d017d2290c$var$Orb = function(x, y) {
    const scale = $6726d1d017d2290c$var$options.scale;
    const dx = x / scale - $6726d1d017d2290c$var$center.x / scale;
    const dy = y / scale - $6726d1d017d2290c$var$center.y / scale;
    const initialAngle = Math.atan2(dy, dx);
    this.angle = initialAngle;
    this.lastAngle = initialAngle;
    this.radius = Math.sqrt(dx * dx + dy * dy);
    this.size = this.radius / 300 + 1;
    this.speed = $6726d1d017d2290c$var$random(1, 10) / 300000 * this.radius + 0.015;
    this.removed = false;
};
$6726d1d017d2290c$var$Orb.prototype.update = function() {
    const speed = $6726d1d017d2290c$var$options.speed;
    this.lastAngle = this.angle;
    this.angle += this.speed * (speed / 50) * $6726d1d017d2290c$var$state.dt;
    if ($6726d1d017d2290c$var$options.spiralInwards) {
        if (this.radius === 0) this.removed = true;
        else this.radius -= 1;
    }
    this.x = this.radius * Math.cos(this.angle);
    this.y = this.radius * Math.sin(this.angle);
};
$6726d1d017d2290c$var$Orb.prototype.render = function(timestamp) {
    this.update();
    const radius = this.radius > 0 ? this.radius : 0;
    // perfect-red = 0
    const offset = timestamp / $6726d1d017d2290c$var$options.speed;
    const hueAngle = (this.angle + 90) / (Math.PI / 180) + offset;
    let style;
    if ($6726d1d017d2290c$var$options.perfectRed) style = `hsl(0, 100%, 50%)`;
    else style = `hsl(${hueAngle}, 100%, 50%)`;
    $6726d1d017d2290c$var$ctx.strokeStyle = style;
    $6726d1d017d2290c$var$ctx.lineWidth = this.size;
    $6726d1d017d2290c$var$ctx.beginPath();
    const increment = 0.001;
    let start;
    let end;
    if ($6726d1d017d2290c$var$options.speed >= 0) {
        start = this.lastAngle;
        end = this.angle + increment;
    } else {
        end = this.lastAngle;
        start = this.angle + increment;
    }
    $6726d1d017d2290c$var$ctx.arc(0, 0, radius, start, end, false);
    $6726d1d017d2290c$var$ctx.stroke();
    $6726d1d017d2290c$var$ctx.closePath();
    if ($6726d1d017d2290c$var$options.centerLight) {
        const alpha = $6726d1d017d2290c$var$options.lightAlpha / 100;
        const style = `hsla(${hueAngle}, 100%, 70%, ${alpha}`;
        $6726d1d017d2290c$var$ctx.lineWidth = .5;
        $6726d1d017d2290c$var$ctx.strokeStyle = style;
        $6726d1d017d2290c$var$ctx.beginPath();
        $6726d1d017d2290c$var$ctx.moveTo(0, 0);
        $6726d1d017d2290c$var$ctx.lineTo(this.x, this.y);
        $6726d1d017d2290c$var$ctx.stroke();
    }
};
const $6726d1d017d2290c$var$createOrb = (x, y)=>{
    console.log(`Creating orb ${x}, ${y}`);
    $6726d1d017d2290c$var$state.orbs.push(new $6726d1d017d2290c$var$Orb(x, y));
};
const $6726d1d017d2290c$var$setup = ()=>{
    const radius = $6726d1d017d2290c$var$options.radius;
    for(let n = $6726d1d017d2290c$var$initialOrbCount; n >= 0; n--){
        const x = $6726d1d017d2290c$var$random($6726d1d017d2290c$var$canvas.width / 2 - radius, $6726d1d017d2290c$var$canvas.width / 2 + radius);
        const y = $6726d1d017d2290c$var$random($6726d1d017d2290c$var$canvas.height / 2 - radius, $6726d1d017d2290c$var$canvas.height / 2 + radius);
        $6726d1d017d2290c$var$createOrb(x, y);
    }
};
const $6726d1d017d2290c$var$clear = ()=>{
    const alpha = $6726d1d017d2290c$var$options.fadeout / 100;
    const style = `rgba(0, 0, 0, ${alpha})`;
    $6726d1d017d2290c$var$ctx.globalCompositeOperation = 'destination-out';
    $6726d1d017d2290c$var$ctx.fillStyle = style;
    $6726d1d017d2290c$var$ctx.fillRect(0, 0, $6726d1d017d2290c$var$canvas.width, $6726d1d017d2290c$var$canvas.height);
    $6726d1d017d2290c$var$ctx.globalCompositeOperation = 'lighter';
};
const $6726d1d017d2290c$var$controls = new dat.GUI({
    autoPlace: false
});
const $6726d1d017d2290c$var$container = document.querySelector("#controlPanel");
$6726d1d017d2290c$var$controls.add($6726d1d017d2290c$var$state, "total").name("Total Orbs").listen();
$6726d1d017d2290c$var$controls.add($6726d1d017d2290c$var$options, "speed").min(-300).max(300).step(10).name("Speed");
$6726d1d017d2290c$var$controls.add($6726d1d017d2290c$var$options, "scale").min(0.5).max(5).step(0.1).name("Scale");
$6726d1d017d2290c$var$controls.add($6726d1d017d2290c$var$options, "fadeout").min(0).max(100).step(1).name("Fadeout (/100)");
$6726d1d017d2290c$var$controls.add($6726d1d017d2290c$var$options, "centerLight").name("Toggle Light");
$6726d1d017d2290c$var$controls.add($6726d1d017d2290c$var$options, "lightAlpha").min(0).max(100).step(1).name("Light Alpha");
$6726d1d017d2290c$var$controls.add($6726d1d017d2290c$var$options, "perfectRed").name("Perfect Red");
$6726d1d017d2290c$var$controls.add($6726d1d017d2290c$var$options, "spiralInwards").name("Spiral Inwwards");
$6726d1d017d2290c$var$container.appendChild($6726d1d017d2290c$var$controls.domElement);
const $6726d1d017d2290c$var$loop = (timestamp)=>{
    window.requestAnimationFrame($6726d1d017d2290c$var$loop);
    $6726d1d017d2290c$var$clear();
    const scale = $6726d1d017d2290c$var$options.scale;
    $6726d1d017d2290c$var$ctx.save();
    $6726d1d017d2290c$var$ctx.translate($6726d1d017d2290c$var$center.x, $6726d1d017d2290c$var$center.y);
    $6726d1d017d2290c$var$ctx.scale(scale, scale);
    $6726d1d017d2290c$var$state.orbs.forEach((orb)=>{
        orb.render(timestamp);
    });
    $6726d1d017d2290c$var$state.orbs = $6726d1d017d2290c$var$state.orbs.filter((orb)=>!orb.removed);
    $6726d1d017d2290c$var$state.total = $6726d1d017d2290c$var$state.orbs.length;
    $6726d1d017d2290c$var$ctx.restore();
};
$6726d1d017d2290c$var$setup();
$6726d1d017d2290c$var$loop();


//# sourceMappingURL=index.e11d6920.js.map
